import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ApiService from "@/services/ApiService.js";
import { UserService, LoggingService } from "@/services/ApiService.js";
import VueDOMPurifyHTML from 'vue-dompurify-html';
import 'vue-material-design-icons/styles.css';

Vue.config.productionTip = false
ApiService.init();

Vue.use(VueDOMPurifyHTML);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!UserService.isLoggedIn()) {
      next({
          path: '/login',
          params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    const root = document.documentElement;
    root.style.setProperty('--body-bg', '#ffffff;');   
    root.style.setProperty('--text-primary', '#343434');
    next();
  }
});

// Error handlers
window.onerror = function (msg, url, line, col, error) {

  // ignores
  if (msg.indexOf('Script error.') > -1) {
      return
  }
  if (msg.includes('ResizeObserver loop')) {
      return
  }
  
  let stack = error && error.stack ? error.stack : 'No stack available'
  let cause = error && error.cause ? error.cause : 'No cause available'

  let details = {
      stack,
      url,
      line,
      col,
      cause
  };

  LoggingService.log('main', msg, details);
} 

// handle promises without explicit catch handler
window.addEventListener('unhandledrejection', function(event) {
  LoggingService.log('main', event.reason.toString(), event);
});

Vue.config.errorHandler = function (err, vm, info) {

  let component = '';

  if (!err) {
      err = 'VueError'
  }

  if (vm.$vnode.componentOptions.tag) {
      component = vm.$vnode.componentOptions.tag
  } else if (vm.$vnode.tag) {
      component = vm.$vnode.tag;
  }
  
  let details = {
      cause: err.cause ? err.cause : 'no specific cause given',
      component: component,
      info
  }
 
  LoggingService.log('main', err.toString(), details)
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
